// Real Google reviews shared by the business owner. These are used verbatim
// on the homepage testimonials section — no fabrication.
export const REAL_REVIEWS = [
  {
    author: "Nick England",
    rating: 5,
    when: "a few months ago",
    text:
      "I had an excellent experience with BM Towing & Recovery when my car broke down on the freeway. My vehicle suddenly lost power while driving. I called BM Towing & Recovery for emergency roadside assistance, and Mani showed up quickly in the time frame he had given me on the phone. Their price was more competitive than some of the other quotes I got. They loaded the car safely and even went out of their way to set the car down in a specific spot in my driveway that was not easy to access.",
  },
  {
    author: "Jayquan Allen",
    rating: 5,
    when: "a few months ago",
    text:
      "Money super wonderful young gentleman and his father helped me out this Saturday morning. My car had ran out of gas in the middle of the street here in Bellevue — they tried helping me push the car, stayed with me during the whole process, and made sure I was safe. Thankfully we got the car running. My situation was way better thanks to these two.",
  },
  {
    author: "Jerrod Holtzman",
    rating: 5,
    when: "a few months ago",
    text:
      "They gave me excellent service when my car broke down unexpectedly. Their dispatcher was very helpful and the driver arrived sooner than expected. He carefully loaded my vehicle and transported it safely. I was very impressed with the professionalism.",
  },
  {
    author: "Anthony Mains",
    rating: 5,
    when: "a few months ago",
    text:
      "When my car battery died late at night, BM Towing came to help. The driver arrived quickly and was very polite. He handled my car with care and made sure everything was done safely. The service was reliable and affordable.",
  },
  {
    author: "Jurgita L",
    rating: 5,
    when: "a few months ago",
    text: "Fantastic service! Quick response, safely towed my car. Definitely recommend.",
  },
  {
    author: "Rim Zend",
    rating: 5,
    when: "a few months ago",
    text:
      "Helped out my shop taking a car to a shop nearby that I couldn't complete. Came fast, good price and handled everything professionally. Will be using long term.",
  },
];
